(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["btf-details-tabs"] && !Shopify.designMode) return;
  try {
    (function () {
    var uid = 0;

    function panelsOf(root) {
      var wrap = root.querySelector('[data-btf-tabs-panels]');
      if (!wrap) return [];
      return Array.prototype.filter.call(wrap.children, function (el) {
        return el.nodeType === 1 && el.hasAttribute('data-tab-panel');
      });
    }

    function buildTabs(root) {
      var nav = root.querySelector('[data-btf-tabs-nav]');
      var wrap = root.querySelector('[data-btf-tabs-panels]');
      if (!nav || !wrap) return;

      Array.prototype.slice.call(wrap.querySelectorAll('.tabs-block__acc-header'))
        .forEach(function (h) { h.parentNode.removeChild(h); });

      var panels = panelsOf(root);
      if (!panels.length) { nav.innerHTML = ''; return; }

      var collapsible = root.hasAttribute('data-cold-collapsible');
      var active = root._tabsActive == null ? (collapsible ? -1 : 0) : root._tabsActive;
      if (active >= panels.length) active = 0;

      if (root._tabsUid == null) root._tabsUid = ++uid;
      var n = root._tabsUid;

      nav.innerHTML = '';
      var tabs = [];
      var headers = [];

      function activate(idx, focus) {
        root._tabsActive = idx;
        panels.forEach(function (p, i) { p.classList.toggle('is-collapsed', i !== idx); if (collapsible) { p.inert = i !== idx; p.setAttribute('aria-hidden', i !== idx ? 'true' : 'false'); } });
        tabs.forEach(function (b, i) {
          var on = (i === idx);
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-selected', on ? 'true' : 'false');
          b.tabIndex = on || (idx === -1 && i === 0) ? 0 : -1;
          if (on && focus) b.focus();
        });
        headers.forEach(function (h, i) {
          var on = (i === idx);
          h.classList.toggle('is-open', on);
          h.setAttribute('aria-expanded', on ? 'true' : 'false');
        });
      }

      function onTabKeydown(e) {
        var idx = tabs.indexOf(document.activeElement);
        if (idx < 0) return;
        var next = null;
        if (e.key === 'ArrowRight') next = (idx + 1) % tabs.length;
        else if (e.key === 'ArrowLeft') next = (idx - 1 + tabs.length) % tabs.length;
        else if (e.key === 'Home') next = 0;
        else if (e.key === 'End') next = tabs.length - 1;
        if (next !== null) { e.preventDefault(); activate(next, true); }
      }

      panels.forEach(function (panel, i) {
        var label = panel.getAttribute('data-tab-label') || ('Tab ' + (i + 1));
        var tabId = 'tabs-' + n + '-tab-' + i;
        var panelId = 'tabs-' + n + '-panel-' + i;

        panel.id = panelId;
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', tabId);
        panel.setAttribute('tabindex', '0');

        var tab = document.createElement('button');
        tab.type = 'button';
        tab.className = 'tabs-block__tab';
        tab.id = tabId;
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', panelId);
        tab.textContent = label;
        tab.addEventListener('click', function () { activate(collapsible && root._tabsActive === i ? -1 : i); });
        tab.addEventListener('keydown', onTabKeydown);
        nav.appendChild(tab);
        tabs.push(tab);

        var header = document.createElement('button');
        header.type = 'button';
        header.className = 'tabs-block__acc-header';
        header.setAttribute('aria-controls', panelId);
        var lbl = document.createElement('span');
        lbl.className = 'tabs-block__acc-label';
        lbl.textContent = label;
        var icon = document.createElement('span');
        icon.className = 'tabs-block__acc-icon';
        icon.setAttribute('aria-hidden', 'true');
        header.appendChild(lbl);
        header.appendChild(icon);
        header.addEventListener('click', function () { activate(collapsible && root._tabsActive === i ? -1 : i); });
        wrap.insertBefore(header, panel);
        headers.push(header);
      });

      root._tabsActivate = activate;
      activate(active);
      root.setAttribute('data-btf-tabs-ready', '');
    }

    function buildAll(scope) {
      (scope || document).querySelectorAll('[data-btf-tabs]').forEach(buildTabs);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { buildAll(); });
    } else {
      buildAll();
    }

    document.addEventListener('shopify:section:load', function (e) { buildAll(e.target); });
    document.addEventListener('shopify:block:select', function (e) {
      var root = e.target.closest('[data-btf-tabs]');
      if (!root || !root._tabsActivate) return;
      var panel = e.target.closest('[data-tab-panel]');
      if (!panel) return;
      var idx = panelsOf(root).indexOf(panel);
      if (idx > -1) root._tabsActivate(idx);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["carousel"] && !Shopify.designMode) return;
  try {
    (function () {
    function initCarousel(root) {
      if (typeof Swiper === 'undefined') return false;

      var viewport = root.querySelector('.swiper');
      var wrapper = viewport && viewport.querySelector('.swiper-wrapper');
      if (!viewport || !wrapper) return true;

      var NON_SLIDE = { LINK: 1, STYLE: 1, SCRIPT: 1, TEMPLATE: 1, META: 1, NOSCRIPT: 1 };
      var slides = [];
      Array.prototype.slice.call(wrapper.children).forEach(function (el) {
        if (el.nodeType !== 1) return;
        if (NON_SLIDE[el.tagName]) { root.appendChild(el); return; }
        el.classList.add('swiper-slide');
        slides.push(el);
      });

      if (root._swiper) { root._swiper.update(); return true; }
      if (!slides.length) { root.dataset.carouselInit = 'true'; return true; }

      var opts = {};
      try { opts = JSON.parse(root.getAttribute('data-swiper-opts') || '{}'); }
      catch (e) { opts = {}; }

      if (opts.autoplay && window.matchMedia &&
          window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        delete opts.autoplay;
      }

      var nextEl = root.querySelector('.swiper-button-next');
      var prevEl = root.querySelector('.swiper-button-prev');
      if (nextEl && prevEl) opts.navigation = { nextEl: nextEl, prevEl: prevEl };

      var pagination = root.querySelector('.swiper-pagination');
      if (pagination) opts.pagination = { el: pagination, clickable: true, dynamicBullets: slides.length > 7 };

      root._swiper = new Swiper(viewport, opts);
      root.dataset.carouselInit = 'true';
      return true;
    }

    function initAll(scope) {
      var ok = true;
      (scope || document).querySelectorAll('.carousel-block[data-carousel]').forEach(function (root) {
        if (!initCarousel(root)) ok = false;
      });
      dedupeLabels();
      return ok;
    }

    function dedupeLabels() {
      var seen = {};
      document.querySelectorAll('.carousel-block__viewport[aria-label]').forEach(function (el) {
        var label = el.getAttribute('aria-label');
        if (seen[label]) el.setAttribute('aria-label', label + ' ' + ++seen[label]);
        else seen[label] = 1;
      });
    }

    function boot() {
      if (!initAll()) window.addEventListener('load', function () { initAll(); }, { once: true });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
    document.addEventListener('shopify:block:select', function (e) {
      var root = e.target.closest('[data-carousel]');
      if (root && root._swiper) {
        var idx = Array.prototype.indexOf.call(root._swiper.slides, e.target.closest('.swiper-slide'));
        if (idx > -1) root._swiper.slideTo(idx);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pdp-addons"] && !Shopify.designMode) return;
  try {
    document.addEventListener('variant:change', (event) => {
    const variantId = event.detail?.variantId;
    const ProductAddons = customElements.get('product-addons');
    if (!variantId || !ProductAddons?.showByVariant) return;

    document.querySelectorAll('.pdp-addons product-addons.variant-addons-enabled').forEach((instance) => {
      ProductAddons.hideAll(instance);
      ProductAddons.showByVariant(instance, variantId);
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pdp-description"] && !Shopify.designMode) return;
  try {
    if (!window.pdpDescriptionAnchorBound) {
    window.pdpDescriptionAnchorBound = true;

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('.pdp-description__anchor');
      if (!trigger) return;

      const targetId = trigger.dataset.pdpAnchorTarget;
      if (!targetId) return;

      const target =
        document.querySelector(`.section-accordion-section details[id="${targetId}"]`) ||
        document.getElementById(targetId);
      if (!target) return;

      if (target.tagName === 'DETAILS') {
        target.setAttribute('open', 'true');
      }

      const offset = target.getBoundingClientRect().top + window.scrollY - 100;
      window.scrollTo({ top: offset, behavior: 'smooth' });
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pdp-media-gallery"] && !Shopify.designMode) return;
  try {
    const galleryVideoIcons = {
    play: '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M8 5v14l11-7z" fill="currentColor"/></svg>',
    pause:
      '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="M7 5h3.5v14H7zm6.5 0H17v14h-3.5z" fill="currentColor"/></svg>',
  };

  const skipGalleryAutoplay = () =>
    window.matchMedia('(prefers-reduced-motion: reduce)').matches || Boolean(navigator.connection?.saveData);

  const galleryZoomOpen = (media) => Boolean(media.closest('media-gallery')?.querySelector('zoom-dialog dialog[open]'));

  const isGalleryVideo = (element) =>
    element instanceof HTMLVideoElement &&
    Boolean(element.closest('media-gallery.pdp-media-gallery')) &&
    !element.closest('zoom-dialog');

  const autoPauseGalleryVideo = (video) => {
    if (video.paused) return;
    video.dataset.autoPaused = 'true';
    video.pause();
  };

  const unloadGalleryEmbed = (media) => {
    const frame = media.querySelector(':scope > iframe');
    if (!frame) return;
    const hadFocus = media.contains(document.activeElement);
    frame.remove();
    media.removeAttribute('loaded');
    if (hadFocus) media.querySelector('.deferred-media__poster-button')?.focus({ preventScroll: true });
  };

  const stopOtherGalleryMedia = (media) => {
    const gallery = media.closest('media-gallery');
    if (!gallery) return;
    gallery.querySelectorAll('deferred-media > video').forEach((video) => {
      if (video.parentElement !== media) autoPauseGalleryVideo(video);
    });
    gallery.querySelectorAll('deferred-media').forEach((other) => {
      if (other !== media) unloadGalleryEmbed(other);
    });
  };

  const galleryToggleTabIndex = (media) => (media.dataset.inView || !media.closest('slideshow-slide') ? 0 : -1);

  const toggleGalleryVideo = (video) => {
    if (!video.paused) {
      video.pause();
      return;
    }
    if (video.ended) video.currentTime = 0;
    video.play().catch(() => {});
  };

  const syncGalleryVideoToggle = (media, video) => {
    media.toggleAttribute('data-paused', video.paused);
    const toggle = media.querySelector(':scope > .pdp-video-toggle');
    if (!toggle) return;
    toggle.setAttribute('aria-label', video.paused ? 'Play video' : 'Pause video');
    toggle.innerHTML = video.paused ? galleryVideoIcons.play : galleryVideoIcons.pause;
  };

  const loadGalleryMedia = (media) => {
    const existing = media.querySelector(':scope > video, :scope > iframe, :scope > model-viewer');
    if (existing) return existing;

    const content = media.querySelector(':scope > template')?.content.firstElementChild?.cloneNode(true);
    const element = content?.matches('video, iframe, model-viewer')
      ? content
      : content?.querySelector('video, iframe, model-viewer');
    if (!element) return null;

    if (!(element instanceof HTMLVideoElement)) {
      const hadFocus = media.contains(document.activeElement);
      stopOtherGalleryMedia(media);
      media.append(element);
      media.setAttribute('loaded', 'true');
      if (hadFocus) element.focus({ preventScroll: true });
      return element;
    }

    element.muted = true;
    element.playsInline = true;

    element.addEventListener('play', () => {
      delete element.dataset.userPaused;
      if (!element.paused) stopOtherGalleryMedia(media);
      syncGalleryVideoToggle(media, element);
    });

    element.addEventListener('playing', () => {
      if (media.hasAttribute('loaded')) return;
      const hadFocus = media.contains(document.activeElement);
      media.setAttribute('loaded', 'true');
      if (hadFocus) (media.querySelector(':scope > .pdp-video-toggle') || element).focus({ preventScroll: true });
    });

    element.addEventListener('pause', () => {
      syncGalleryVideoToggle(media, element);
      if (element.dataset.autoPaused) {
        delete element.dataset.autoPaused;
        return;
      }
      if (!element.ended && media.dataset.inView) element.dataset.userPaused = 'true';
    });

    media.append(element);

    if (!media.closest('zoom-dialog')) {
      const toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'pdp-video-toggle';
      toggle.tabIndex = galleryToggleTabIndex(media);
      toggle.addEventListener('click', () => toggleGalleryVideo(element));
      media.append(toggle);
    }

    syncGalleryVideoToggle(media, element);
    return element;
  };

  const playVisibleGalleryVideo = (media) => {
    if (media.dataset.videoObserved !== 'video') return;
    if (!media.closest('media-gallery[data-autoplay-videos]') || skipGalleryAutoplay() || galleryZoomOpen(media)) return;

    const video = loadGalleryMedia(media);
    if (!(video instanceof HTMLVideoElement) || video.dataset.userPaused) return;
    if (video.ended) video.currentTime = 0;
    video.play().catch(() => {});
  };

  let galleryPointerStart = null;
  document.addEventListener('pointerdown', (event) => {
    galleryPointerStart = isGalleryVideo(event.target) ? { x: event.clientX, y: event.clientY } : null;
  });

  document.addEventListener('click', (event) => {
    const poster = event.target.closest('media-gallery.pdp-media-gallery .deferred-media__poster-button');
    if (poster) {
      const media = poster.closest('deferred-media');
      const element = media ? loadGalleryMedia(media) : null;
      if (element instanceof HTMLVideoElement) {
        delete element.dataset.userPaused;
        if (element.ended) element.currentTime = 0;
        element.play().catch(() => {});
      }
      return;
    }

    if (!isGalleryVideo(event.target)) return;
    const start = galleryPointerStart;
    galleryPointerStart = null;
    if (start && Math.hypot(event.clientX - start.x, event.clientY - start.y) > 10) return;
    toggleGalleryVideo(event.target);
  });

  const galleryVideoObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const media = entry.target;
        const { width, height } = entry.boundingClientRect;
        const visibleWidth = width ? entry.intersectionRect.width / width : 0;
        const visibleHeight = height
          ? entry.intersectionRect.height / Math.min(height, entry.rootBounds?.height || height)
          : 0;
        const inView = entry.isIntersecting && visibleWidth * visibleHeight >= 0.6;
        const wasInView = Boolean(media.dataset.inView);
        const toggle = media.querySelector(':scope > .pdp-video-toggle');

        if (!inView) {
          delete media.dataset.inView;
          if (toggle) toggle.tabIndex = galleryToggleTabIndex(media);
          const video = media.querySelector(':scope > video');
          if (video) autoPauseGalleryVideo(video);
          unloadGalleryEmbed(media);
          return;
        }

        media.dataset.inView = 'true';
        if (toggle) toggle.tabIndex = 0;
        if (!wasInView) playVisibleGalleryVideo(media);
      });
    },
    { threshold: [0, 0.25, 0.5, 0.6, 0.75, 1] }
  );

  const watchGalleryZoom = (gallery) => {
    gallery.querySelectorAll('zoom-dialog dialog').forEach((dialog) => {
      if (dialog.dataset.videoWatch) return;
      dialog.dataset.videoWatch = 'true';

      new MutationObserver(() => {
        if (dialog.open) {
          gallery.querySelectorAll('deferred-media').forEach((media) => {
            if (media.closest('zoom-dialog')) return;
            const video = media.querySelector(':scope > video');
            if (video) autoPauseGalleryVideo(video);
            unloadGalleryEmbed(media);
          });
          return;
        }

        dialog.querySelectorAll('deferred-media').forEach((media) => {
          const video = media.querySelector(':scope > video');
          if (video) autoPauseGalleryVideo(video);
          unloadGalleryEmbed(media);
        });
        gallery.querySelectorAll('deferred-media[data-in-view]').forEach((media) => {
          if (!media.closest('zoom-dialog')) playVisibleGalleryVideo(media);
        });
      }).observe(dialog, { attributes: true, attributeFilter: ['open'] });
    });
  };

  const initGalleryVideos = (root = document) => {
    root.querySelectorAll('media-gallery.pdp-media-gallery').forEach((gallery) => {
      watchGalleryZoom(gallery);
      gallery.querySelectorAll('deferred-media').forEach((media) => {
        if (media.dataset.videoObserved || media.closest('zoom-dialog')) return;
        const content = media.querySelector(':scope > template')?.content;
        const kind = content?.querySelector('video') ? 'video' : content?.querySelector('iframe') ? 'embed' : '';
        if (!kind) return;
        media.dataset.videoObserved = kind;
        galleryVideoObserver.observe(media);
      });
    });
  };

  const syncEkoVariant = (id) => {
    if (!id || !document.querySelector('.pdp-eko-gallery')) return;
    try {
      window.eko?.gallery?.setVariant?.(String(id));
    } catch (error) {}
  };

  const patchEkoGallery = (root) => {
    const label = root.dataset.label;
    root.querySelectorAll('.eko-carousel').forEach((carousel) => {
      if (carousel.getAttribute('tabindex') !== '0') carousel.setAttribute('tabindex', '0');
      if (label && !carousel.getAttribute('aria-label')) carousel.setAttribute('aria-label', label);
    });
    root.querySelectorAll('li[aria-label^="Go to item"], button[aria-label^="Go to item"]').forEach((item) => {
      const text = (item.textContent || '').replace(/\s+/g, ' ').trim();
      if (text && item.getAttribute('aria-label') !== text) item.setAttribute('aria-label', text);
    });
    root.querySelectorAll('.eko-gallery[aria-controls]').forEach((gallery) => {
      const target = gallery.getAttribute('aria-controls');
      if (target && document.getElementById(target)) return;
      if (document.getElementById('MainContent')) {
        if (target !== 'MainContent') gallery.setAttribute('aria-controls', 'MainContent');
      } else {
        gallery.removeAttribute('aria-controls');
      }
    });
  };

  const initEkoGalleries = (root = document) => {
    root.querySelectorAll('.pdp-eko-gallery').forEach((gallery) => {
      if (gallery.dataset.ekoWatch) return;
      gallery.dataset.ekoWatch = 'true';
      patchEkoGallery(gallery);
      new MutationObserver(() => patchEkoGallery(gallery)).observe(gallery, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['aria-label', 'aria-controls', 'tabindex'],
      });
    });
    const input = document.querySelector('form[data-type="add-to-cart-form"] input[name="id"]');
    syncEkoVariant(new URLSearchParams(window.location.search).get('variant') || input?.value);
  };

  document.addEventListener('variant:change', (event) => syncEkoVariant(event.detail?.variantId));

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initGalleryVideos();
      initEkoGalleries();
    });
  } else {
    initGalleryVideos();
    initEkoGalleries();
  }
  document.addEventListener('shopify:section:load', (event) => {
    initGalleryVideos(event.target);
    initEkoGalleries(event.target);
  });
  document.addEventListener('shopify:section:unload', (event) => {
    event.target
      .querySelectorAll('media-gallery.pdp-media-gallery deferred-media[data-video-observed]')
      .forEach((media) => galleryVideoObserver.unobserve(media));
  });

  document.addEventListener('slideshow:select', (event) => {
    if (event.detail?.trigger !== 'scroll') return;

    const strip = event.target
      .closest('.pdp-media-gallery')
      ?.querySelector('.slideshow-controls__thumbnails-container');
    const thumbnail = strip?.querySelectorAll('.slideshow-controls__thumbnail')[event.detail.index];
    if (!thumbnail || !strip.clientWidth) return;

    const stripRect = strip.getBoundingClientRect();
    const thumbnailRect = thumbnail.getBoundingClientRect();
    const offset = thumbnailRect.left + thumbnailRect.width / 2 - (stripRect.left + stripRect.width / 2);
    strip.scrollBy({ left: offset, behavior: 'smooth' });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pdp-price"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pdp-price')) {
    customElements.define(
      'pdp-price',
      class PdpPrice extends HTMLElement {
        connectedCallback() {
          const data = this.querySelector('[data-price-variants]');
          if (!data) return;

          try {
            this.variants = JSON.parse(data.textContent);
          } catch (err) {
            return;
          }

          this.currentId = this.dataset.currentVariant;
          this.currentEl = this.querySelector('[data-price-current]');
          this.compareEl = this.querySelector('[data-price-compare]');
          this.chipEl = this.querySelector('[data-price-chip]');
          this.chipTextEl = this.querySelector('[data-price-chip-text]');
          this.modal = this.querySelector('[data-price-modal]');

          this.onVariantChange = this.onVariantChange.bind(this);
          document.addEventListener('variant:change', this.onVariantChange);

          this.bindModal();
          this.render();
        }

        disconnectedCallback() {
          document.removeEventListener('variant:change', this.onVariantChange);
          if (this.onKeydown) document.removeEventListener('keydown', this.onKeydown);
        }

        bindModal() {
          if (!this.modal) return;

          this.openButton = this.querySelector('[data-price-tooltip-open]');
          this.openButton?.addEventListener('click', () => this.setModal(true));

          this.querySelectorAll('[data-price-tooltip-close]').forEach((el) =>
            el.addEventListener('click', () => this.setModal(false))
          );

          this.onKeydown = (event) => {
            if (event.key === 'Escape' && !this.modal.hidden) this.setModal(false);
          };
          document.addEventListener('keydown', this.onKeydown);
        }

        setModal(open) {
          this.modal.hidden = !open;
          if (open) {
            this.modal.querySelector('[data-price-tooltip-close]')?.focus();
          } else {
            this.openButton?.focus();
          }
        }

        onVariantChange(event) {
          const id = event?.detail?.variantId;
          if (!id) return;
          this.currentId = id;
          this.render();
        }

        render() {
          const variant =
            this.variants.find((item) => String(item.id) === String(this.currentId)) || this.variants[0];
          if (!variant) return;

          if (this.currentEl) this.currentEl.textContent = variant.price;

          if (this.compareEl) {
            const show = Boolean(variant.onSale && variant.compareAt);
            this.compareEl.hidden = !show;
            this.compareEl.textContent = show ? variant.compareAt : '';
          }

          if (this.chipEl) {
            const show = Boolean(variant.hasDiscount > 0 && variant.discountText);
            this.chipEl.hidden = !show;
            if (this.chipTextEl) this.chipTextEl.textContent = show ? variant.discountText : '';
          }

        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pdp-sticky-buy-bar"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pdp-sticky-buy-bar')) {
    customElements.define(
      'pdp-sticky-buy-bar',
      class PdpStickyBuyBar extends HTMLElement {
        connectedCallback() {
          const data = this.querySelector('[data-sticky-variants]');
          if (!data) return;

          try {
            this.variants = JSON.parse(data.textContent);
          } catch (err) {
            return;
          }

          this.currentId = this.dataset.currentVariant;
          this.panel = this.querySelector('.pdp-sticky-bar__panel');
          this.priceEl = this.querySelector('[data-sticky-price]');
          this.compareEl = this.querySelector('[data-sticky-compare]');
          this.chipEl = this.querySelector('[data-sticky-chip]');
          this.chipTextEl = this.querySelector('[data-sticky-chip-text]');
          this.button = this.querySelector('[data-sticky-atc]');
          this.buttonLabelEl = this.button?.querySelector('span');
          this.defaultLabel = this.buttonLabelEl?.textContent.trim() || 'Add to Cart';
          this.alaEl = this.querySelector('[data-sticky-ala]');
          this.header = document.querySelector('header');
          this.watchFinancing();

          this.onVariantChange = this.onVariantChange.bind(this);
          document.addEventListener('variant:change', this.onVariantChange);
          document.addEventListener('upgrade:change', this.onVariantChange);

          this.onScroll = this.onScroll.bind(this);
          window.addEventListener('scroll', this.onScroll, { passive: true });
          window.addEventListener('resize', this.onScroll, { passive: true });

          this.linkToForm();
          this.bindFinancing();
          this.render();
          this.pinned = false;
          this.onScroll();
        }

        disconnectedCallback() {
          clearTimeout(this.leaveTimer);
          clearTimeout(this.enterTimer);
          window.removeEventListener('scroll', this.onScroll);
          window.removeEventListener('resize', this.onScroll);
          if (this.frame) cancelAnimationFrame(this.frame);
          document.removeEventListener('variant:change', this.onVariantChange);
          document.removeEventListener('upgrade:change', this.onVariantChange);
          this.alaObserver?.disconnect();
        }

        pinAllowed() {
          const desktop = window.matchMedia('(min-width: 750px)').matches;
          const flag = desktop ? this.dataset.desktopEnabled : this.dataset.mobileEnabled;
          return flag === 'true';
        }

        topOffset() {
          const bottom = this.header ? this.header.getBoundingClientRect().bottom : 0;
          return Math.max(0, Math.round(bottom));
        }

        onScroll() {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = null;
            const top = this.topOffset();
            const rect = this.getBoundingClientRect();
            const allowed = this.pinAllowed();
            const settled = Math.round(rect.bottom) < Math.round(window.innerHeight) - 1;
            this.style.setProperty('--pdp-sticky-top', `${top}px`);
            this.classList.toggle('pdp-sticky-bar--settled', settled);
            if (!allowed) {
              this.style.removeProperty('--pdp-sticky-runway');
            } else if (settled) {
              const end = document.body.getBoundingClientRect().bottom;
              this.style.setProperty('--pdp-sticky-runway', `${Math.max(0, Math.floor(end - rect.bottom))}px`);
            }
            if (this.pinned) this.measureViewport(rect);
            const shouldPin = allowed && rect.top <= top;
            if (shouldPin !== this.pinned) this.setPinned(shouldPin);
          });
        }

        measureViewport(rect = this.getBoundingClientRect()) {
          this.style.setProperty('--pdp-sticky-host-left', `${rect.left}px`);
          this.style.setProperty('--pdp-sticky-viewport', `${document.documentElement.clientWidth}px`);
        }

        setPinned(pinned) {
          const wasPinned = this.classList.contains('pdp-sticky-bar--pinned');
          this.pinned = pinned;
          clearTimeout(this.leaveTimer);
          clearTimeout(this.enterTimer);

          if (!pinned) {
            if (!wasPinned) return;
            this.classList.add('pdp-sticky-bar--animating');
            this.classList.remove('pdp-sticky-bar--expanded');
            this.leaveTimer = setTimeout(() => {
              if (this.pinned) return;
              this.classList.remove('pdp-sticky-bar--pinned', 'pdp-sticky-bar--animating');
              this.style.minHeight = '';
            }, 360);
            return;
          }

          this.measureViewport();

          if (wasPinned) {
            this.classList.add('pdp-sticky-bar--animating', 'pdp-sticky-bar--expanded');
            this.enterTimer = setTimeout(() => {
              if (this.pinned) this.classList.remove('pdp-sticky-bar--animating');
            }, 360);
            return;
          }

          this.style.minHeight = `${this.offsetHeight}px`;
          this.classList.remove('pdp-sticky-bar--animating');
          this.classList.add('pdp-sticky-bar--pinned');

          requestAnimationFrame(() =>
            requestAnimationFrame(() => {
              if (!this.pinned) return;
              this.classList.add('pdp-sticky-bar--animating', 'pdp-sticky-bar--expanded');
              this.enterTimer = setTimeout(() => {
                if (this.pinned) this.classList.remove('pdp-sticky-bar--animating');
              }, 360);
            })
          );
        }

        linkToForm() {
          const form =
            document.querySelector('[data-type="add-to-cart-form"]') ||
            document.querySelector('form[action*="/cart/add"]');

          const formId = form?.getAttribute('id');

          if (formId) {
            this.button?.setAttribute('form', formId);
          } else if (this.button) {
            this.button.type = 'button';
            this.button.addEventListener('click', () => {
              const primary = document.querySelector('form[action*="/cart/add"] [type="submit"]');
              primary?.click();
            });
          }
        }

        financingSource() {
          const candidates = document.querySelectorAll('.bread-pdp-ala');
          return [...candidates].find((element) => !this.contains(element)) || null;
        }

        syncFinancing() {
          if (!this.alaEl) return;

          const source = this.financingSource();
          const markup = source?.querySelector('.bread-pdp-ala__now') ? source.innerHTML : '';

          if (this.alaEl.innerHTML !== markup) this.alaEl.innerHTML = markup;
          this.alaEl.hidden = markup === '';
        }

        watchFinancing() {
          if (!this.alaEl) return;
          this.syncFinancing();

          const placements = [...document.querySelectorAll('bread-pdp-placement')].filter(
            (element) => !this.contains(element)
          );
          if (!placements.length) return;

          this.alaObserver = new MutationObserver(() => this.syncFinancing());
          placements.forEach((element) =>
            this.alaObserver.observe(element, { childList: true, subtree: true, characterData: true })
          );
        }

        bindFinancing() {
          this.alaEl?.addEventListener('click', () => {
            const placement = document.querySelector('bread-pdp-placement');
            if (placement) placement.click();
          });
        }

        onVariantChange(event) {
          const id = event?.detail?.variantId;
          if (id) this.currentId = id;
          this.render();
        }

        render() {
          const variant =
            this.variants.find((item) => String(item.id) === String(this.currentId)) || this.variants[0];
          if (!variant) return;

          if (this.priceEl) this.priceEl.textContent = variant.price;

          if (this.compareEl) {
            const show = Boolean(variant.onSale && variant.compareAt);
            this.compareEl.hidden = !show;
            this.compareEl.textContent = show ? variant.compareAt : '';
          }

          if (this.chipEl) {
            const show = Boolean(variant.hasDiscount > 0 && variant.discountText);
            this.chipEl.hidden = !show;
            if (this.chipTextEl) this.chipTextEl.textContent = show ? variant.discountText : '';
          }

          if (this.button) {
            this.button.disabled = !variant.available;
            if (this.buttonLabelEl) {
              this.buttonLabelEl.textContent = variant.available ? this.defaultLabel : 'Sold out';
            }
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pdp-trust-prop"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pdp-trust-tip')) {
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      document.querySelectorAll('pdp-trust-tip').forEach((tip) => tip.setAttribute('data-tip-dismissed', ''));
    });

    customElements.define(
      'pdp-trust-tip',
      class PdpTrustTip extends HTMLElement {
        connectedCallback() {
          this.tip = this.querySelector('.pdp-trust-prop__tip');
          this.onShow = this.onShow.bind(this);
          this.onHide = this.onHide.bind(this);
          this.addEventListener('pointerenter', this.onShow);
          this.addEventListener('focusin', this.onShow);
          this.addEventListener('pointerleave', this.onHide);
          this.addEventListener('focusout', this.onHide);
        }

        disconnectedCallback() {
          this.removeEventListener('pointerenter', this.onShow);
          this.removeEventListener('focusin', this.onShow);
          this.removeEventListener('pointerleave', this.onHide);
          this.removeEventListener('focusout', this.onHide);
        }

        onShow() {
          this.removeAttribute('data-tip-dismissed');
          if (!this.tip) return;

          this.style.setProperty('--pdp-tip-shift', '0px');
          const rect = this.tip.getBoundingClientRect();
          const gutter = 16;
          let shift = 0;
          if (rect.left < gutter) shift = gutter - rect.left;
          else if (rect.right > window.innerWidth - gutter) shift = window.innerWidth - gutter - rect.right;
          this.style.setProperty('--pdp-tip-shift', `${Math.round(shift)}px`);
        }

        onHide() {
          this.removeAttribute('data-tip-dismissed');
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pdp-trust-props"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ships-by-note')) {
    customElements.define(
      'ships-by-note',
      class ShipsByNote extends HTMLElement {
        connectedCallback() {
          const data = this.querySelector('[data-ships-by-variants]');
          if (!data) return;

          try {
            this.variants = JSON.parse(data.textContent);
          } catch (err) {
            return;
          }

          this.valueEl = this.querySelector('[data-ships-by-value]');
          this.appendEl = this.querySelector('[data-ships-by-append]');
          this.appendTextEl = this.querySelector('[data-ships-by-append-text]');
          this.disclaimerEl = this.querySelector('[data-ships-by-disclaimer]');
          this.fallback = this.dataset.fallback || '';

          this.onExternalChange = this.onExternalChange.bind(this);
          document.addEventListener('change', this.onExternalChange);
          document.addEventListener('variant:change', this.onExternalChange);
          window.addEventListener('popstate', this.onExternalChange);

          ShipsByNote.countryCode().then((code) => {
            this.countryCode = code;
            this.render();
          });
        }

        disconnectedCallback() {
          document.removeEventListener('change', this.onExternalChange);
          document.removeEventListener('variant:change', this.onExternalChange);
          window.removeEventListener('popstate', this.onExternalChange);
        }

        static countryCode() {
          if (!window.shipsByCountryPromise) {
            window.shipsByCountryPromise = fetch('/browsing_context_suggestions.json')
              .then((response) => (response.ok ? response.json() : null))
              .then((body) => body?.detected_values?.country?.handle || null)
              .catch(() => null);
          }
          return window.shipsByCountryPromise;
        }

        onExternalChange(event) {
          const explicitId = event?.detail?.variantId;
          if (explicitId) {
            this.forcedVariantId = String(explicitId);
          }
          this.render();
        }

        get isCanada() {
          return this.countryCode === 'CA' || window.location.href.includes('/en-ca');
        }

        currentVariant() {
          const fromUrl = new URLSearchParams(window.location.search).get('variant');
          const id = this.forcedVariantId || fromUrl || this.dataset.defaultVariant;
          return this.variants.find((variant) => String(variant.id) === String(id)) || this.variants[0];
        }

        static addBusinessDays(startDate, daysToAdd) {
          const date = new Date(startDate.getTime());
          let remaining = daysToAdd;
          while (remaining > 0) {
            date.setDate(date.getDate() + 1);
            if (date.getDay() !== 0 && date.getDay() !== 6) remaining--;
          }
          return date;
        }

        static ordinalSuffix(number) {
          if (number >= 11 && number <= 13) return 'th';
          switch (number % 10) {
            case 1:
              return 'st';
            case 2:
              return 'nd';
            case 3:
              return 'rd';
            default:
              return 'th';
          }
        }

        static formatShipsBy(date) {
          const label = date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
          return `Ships by ${label}${ShipsByNote.ordinalSuffix(date.getDate())}`;
        }

        normalizeDate(value) {
          if (!value) return null;
          const parsed = new Date(value);
          if (isNaN(parsed.getTime())) return null;
          const corrected = new Date(parsed.getTime() + parsed.getTimezoneOffset() * 60000);
          if (this.isCanada) corrected.setDate(corrected.getDate() + 14);
          return corrected;
        }

        normalizeDays(value) {
          const days = parseInt(value, 10);
          if (isNaN(days)) return null;
          return this.isCanada ? days + 14 : days;
        }

        message(variant) {
          const leadTime = (variant.leadTime || '').trim();
          if (leadTime) return leadTime;

          const date = this.normalizeDate(variant.leadTimeDate);
          if (date) return ShipsByNote.formatShipsBy(date);

          const days = this.normalizeDays(variant.leadDays);
          if (days && days > 0) return ShipsByNote.formatShipsBy(ShipsByNote.addBusinessDays(new Date(), days + 1));

          return this.fallback;
        }

        shipDate(variant) {
          const date = this.normalizeDate(variant.leadTimeDate);
          if (date) return date;

          const days = this.normalizeDays(variant.leadDays);
          if (days && days > 0) return ShipsByNote.addBusinessDays(new Date(), days + 1);

          return null;
        }

        syncCartProperties(variant, message) {
          const shipmentInput = document.querySelector('[name="properties[Shipment]"]');
          const dateInput = document.querySelector('[name="properties[_ships_by_date]"]');
          if (!shipmentInput && !dateInput) return;

          const date = this.shipDate(variant);
          if (shipmentInput) shipmentInput.value = message || '';
          if (dateInput) {
            dateInput.value = date
              ? date.toLocaleDateString('en-US', { year: 'numeric', month: 'numeric', day: 'numeric' })
              : 'not-set';
          }
        }

        render() {
          const variant = this.currentVariant();
          if (!variant) return;

          const message = this.message(variant);
          this.hidden = !message;
          if (this.valueEl) this.valueEl.textContent = message;
          this.syncCartProperties(variant, message);

          if (this.appendEl) {
            const appendText = (variant.appendText || '').trim();
            this.appendEl.hidden = !appendText;
            if (this.appendTextEl) this.appendTextEl.textContent = appendText;
          }

          if (this.disclaimerEl) {
            const disclaimer = (variant.disclaimer || '').trim();
            this.disclaimerEl.hidden = !disclaimer;
            this.disclaimerEl.textContent = disclaimer;
          }
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pdp-variant-options"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pdp-variant-options')) {
    customElements.define(
      'pdp-variant-options',
      class PdpVariantOptions extends HTMLElement {
        connectedCallback() {
          const data = this.querySelector('[data-variant-data]');
          if (!data) return;

          try {
            const parsed = JSON.parse(data.textContent);
            this.variants = parsed.variants || [];
            this.currentVariantId = parsed.current;
          } catch (err) {
            return;
          }

          this.priceMode = this.dataset.priceMode || 'absolute';
          this.groups = Array.from(this.querySelectorAll('.pdp-options__group')).map((el) => ({
            el,
            index: parseInt(el.dataset.optionPosition, 10) - 1,
            style: el.dataset.optionStyle,
            baseValue: el.dataset.baseValue,
            upgradeValue: el.dataset.upgradeValue,
            inputs: Array.from(el.querySelectorAll('.pdp-options__input')),
          }));

          this.onChange = this.onChange.bind(this);
          this.addEventListener('change', this.onChange);

          this.refresh();
        }

        disconnectedCallback() {
          this.removeEventListener('change', this.onChange);
        }

        valueFor(group) {
          if (group.style === 'checkbox') {
            const toggle = group.inputs[0];
            if (!toggle) return null;
            return toggle.checked ? group.upgradeValue : group.baseValue;
          }
          return group.inputs.find((input) => input.checked)?.value ?? null;
        }

        selection() {
          const base = this.variants.find((v) => String(v.id) === String(this.currentVariantId));
          const values = base ? base.options.slice() : [];
          this.groups.forEach((group) => {
            const value = this.valueFor(group);
            if (value != null) values[group.index] = value;
          });
          return values;
        }

        matchVariant(values) {
          return this.variants.find((v) => v.options.every((option, i) => option === values[i]));
        }

        onChange() {
          const variant = this.matchVariant(this.selection());
          if (variant) {
            this.currentVariantId = variant.id;
            this.syncForms(variant);

            const url = new URL(window.location.href);
            url.searchParams.set('variant', variant.id);
            window.history.replaceState({}, '', url.toString());

            const detail = { variantId: variant.id, variant, options: this.selection() };
            document.dispatchEvent(new CustomEvent('variant:change', { bubbles: true, detail }));
            document.dispatchEvent(new CustomEvent('upgrade:change', { bubbles: true, detail }));
          }
          this.refresh();
        }

        syncForms(variant) {
          const id = String(variant.id);
          document.querySelectorAll('form[data-type="add-to-cart-form"] input[name="id"]').forEach((input) => {
            if (input.value === id) return;
            input.setAttribute('value', id);
            input.value = id;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          });
        }

        money(cents) {
          return '$' + (cents / 100).toLocaleString('en-US', { maximumFractionDigits: 0 });
        }

        refresh() {
          const values = this.selection();

          this.groups.forEach((group) => {
            group.inputs.forEach((input) => {
              const candidate = values.slice();
              candidate[group.index] = group.style === 'checkbox' ? group.upgradeValue : input.value;
              const match = this.matchVariant(candidate);
              const available = Boolean(match && match.available);
              input.disabled = !available;
              const note = input.nextElementSibling?.querySelector('[data-unavailable-note]');
              if (note) note.hidden = available;
            });

            group.el.querySelectorAll('[data-option-price]').forEach((el) => {
              const value = el.dataset.optionPrice;
              const withValue = values.slice();
              withValue[group.index] = value;
              const target = this.matchVariant(withValue);

              const baseline = values.slice();
              baseline[group.index] = group.baseValue;
              const from = this.matchVariant(baseline);

              if (!target || !from || value === group.baseValue) {
                el.textContent = '';
                return;
              }

              const delta = target.price - from.price;
              if (delta === 0) {
                el.textContent = '';
                return;
              }

              el.textContent =
                this.priceMode === 'absolute'
                  ? this.money(delta)
                  : (delta > 0 ? '+' : '-') + this.money(Math.abs(delta));
            });
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["tabs"] && !Shopify.designMode) return;
  try {
    (function () {
    var uid = 0;

    function panelsOf(root) {
      var wrap = root.querySelector('[data-tabs-panels]');
      if (!wrap) return [];
      return Array.prototype.filter.call(wrap.children, function (el) {
        return el.nodeType === 1 && el.hasAttribute('data-tab-panel');
      });
    }

    function buildTabs(root) {
      var nav = root.querySelector('[data-tabs-nav]');
      var wrap = root.querySelector('[data-tabs-panels]');
      if (!nav || !wrap) return;

      Array.prototype.slice.call(wrap.querySelectorAll('.tabs-block__acc-header'))
        .forEach(function (h) { h.parentNode.removeChild(h); });

      var panels = panelsOf(root);
      if (!panels.length) { nav.innerHTML = ''; return; }

      var active = root._tabsActive || 0;
      if (active >= panels.length) active = 0;

      if (root._tabsUid == null) root._tabsUid = ++uid;
      var n = root._tabsUid;

      nav.innerHTML = '';
      var tabs = [];
      var headers = [];

      function activate(idx, focus) {
        root._tabsActive = idx;
        panels.forEach(function (p, i) { p.classList.toggle('is-collapsed', i !== idx); });
        tabs.forEach(function (b, i) {
          var on = (i === idx);
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-selected', on ? 'true' : 'false');
          b.tabIndex = on ? 0 : -1;
          if (on && focus) b.focus();
        });
        headers.forEach(function (h, i) {
          var on = (i === idx);
          h.classList.toggle('is-open', on);
          h.setAttribute('aria-expanded', on ? 'true' : 'false');
        });
      }

      function onTabKeydown(e) {
        var idx = tabs.indexOf(document.activeElement);
        if (idx < 0) return;
        var next = null;
        if (e.key === 'ArrowRight') next = (idx + 1) % tabs.length;
        else if (e.key === 'ArrowLeft') next = (idx - 1 + tabs.length) % tabs.length;
        else if (e.key === 'Home') next = 0;
        else if (e.key === 'End') next = tabs.length - 1;
        if (next !== null) { e.preventDefault(); activate(next, true); }
      }

      panels.forEach(function (panel, i) {
        var label = panel.getAttribute('data-tab-label') || ('Tab ' + (i + 1));
        var tabId = 'tabs-' + n + '-tab-' + i;
        var panelId = 'tabs-' + n + '-panel-' + i;

        panel.id = panelId;
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', tabId);
        panel.setAttribute('tabindex', '0');

        var tab = document.createElement('button');
        tab.type = 'button';
        tab.className = 'tabs-block__tab';
        tab.id = tabId;
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', panelId);
        tab.textContent = label;
        tab.addEventListener('click', function () { activate(i); });
        tab.addEventListener('keydown', onTabKeydown);
        nav.appendChild(tab);
        tabs.push(tab);

        var header = document.createElement('button');
        header.type = 'button';
        header.className = 'tabs-block__acc-header';
        header.setAttribute('aria-controls', panelId);
        var lbl = document.createElement('span');
        lbl.className = 'tabs-block__acc-label';
        lbl.textContent = label;
        var icon = document.createElement('span');
        icon.className = 'tabs-block__acc-icon';
        icon.setAttribute('aria-hidden', 'true');
        header.appendChild(lbl);
        header.appendChild(icon);
        header.addEventListener('click', function () { activate(i); });
        wrap.insertBefore(header, panel);
        headers.push(header);
      });

      root._tabsActivate = activate;
      activate(active);
    }

    function buildAll(scope) {
      (scope || document).querySelectorAll('[data-tabs]').forEach(buildTabs);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { buildAll(); });
    } else {
      buildAll();
    }

    document.addEventListener('shopify:section:load', function (e) { buildAll(e.target); });
    document.addEventListener('shopify:block:select', function (e) {
      var root = e.target.closest('[data-tabs]');
      if (!root || !root._tabsActivate) return;
      var panel = e.target.closest('[data-tab-panel]');
      if (!panel) return;
      var idx = panelsOf(root).indexOf(panel);
      if (idx > -1) root._tabsActivate(idx);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["v2-video"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', function (event) {
    var trigger = event.target.closest('.v2-video__play');
    if (!trigger) return;

    var root = trigger.closest('.v2-video');
    if (!root) return;

    root.classList.add('is-playing');

    var nativeVideo = root.querySelector('video');
    if (nativeVideo) {
      var lazySources = nativeVideo.querySelectorAll('source[data-vb-src]');
      if (lazySources.length) {
        lazySources.forEach(function (source) {
          source.src = source.getAttribute('data-vb-src');
          source.removeAttribute('data-vb-src');
        });
        nativeVideo.load();
      }
      nativeVideo.setAttribute('controls', '');
      nativeVideo.play();
      return;
    }

    var embed = root.querySelector('.v2-video__embed');
    if (embed && embed.dataset.src && !embed.querySelector('iframe')) {
      var iframe = document.createElement('iframe');
      iframe.setAttribute('allow', 'autoplay; encrypted-media; fullscreen; picture-in-picture');
      iframe.setAttribute('allowfullscreen', '');
      iframe.setAttribute('title', 'Video');
      iframe.src = embed.dataset.src;
      embed.appendChild(iframe);
    }
  });

  (function () {
    var io = null;

    function playInView(root) {
      var video = root.querySelector('video');
      if (video) {
        var lazy = video.querySelectorAll('source[data-vb-src]');
        if (lazy.length) {
          lazy.forEach(function (s) {
            s.src = s.getAttribute('data-vb-src');
            s.removeAttribute('data-vb-src');
          });
          video.load();
        }
        video.muted = true;
        video.setAttribute('playsinline', '');
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
        root.classList.add('is-playing');
        return;
      }
      var embed = root.querySelector('.v2-video__embed');
      if (embed && embed.dataset.src && !embed.querySelector('iframe')) {
        var src = embed.dataset.src;
        src += (src.indexOf('?') > -1 ? '&' : '?') + 'mute=1&muted=1';
        var iframe = document.createElement('iframe');
        iframe.setAttribute('allow', 'autoplay; encrypted-media; fullscreen; picture-in-picture');
        iframe.setAttribute('allowfullscreen', '');
        iframe.setAttribute('title', 'Video');
        iframe.src = src;
        embed.appendChild(iframe);
        root.classList.add('is-playing');
      }
    }

    function pauseInView(root) {
      var video = root.querySelector('video');
      if (video && !video.paused) video.pause();
    }

    function setup() {
      if (!('IntersectionObserver' in window)) return;
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      if (!io) {
        io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) playInView(entry.target);
            else pauseInView(entry.target);
          });
        }, { threshold: 0.5 });
      }
      document.querySelectorAll('.v2-video[data-play-in-view]').forEach(function (root) {
        if (root.dataset.inViewBound) return;
        root.dataset.inViewBound = '1';
        io.observe(root);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', setup);
    } else {
      setup();
    }
    document.addEventListener('shopify:section:load', setup);
  })();
  } catch(e) { console.error(e); }
})();

})();
